export const ONBOARDING_STAR_TWINKLE_CYCLE_S = 2.4;
